<div *ngIf="notes" class="container-fluid">



  <div class="row">
    <div class="col-md-10">
      <h3 i18n>Quote Notes</h3>
      <p i18n>List of Notes created for quote.</p>
    </div>
    <div class="col-md-2">
      <a routerLink="/quote/addNote/{{quoteId}}" class="btn btn-secondary float-right" style="margin:2px;" i18n>Add</a>
    </div>
  </div>

  <div class="row">
    <div class="col-12">&nbsp;</div>
  </div>


  <table class="table table-striped">
    <thead>
      <tr>
        <th i18n>Date Created</th>
        <th i18n>Created By</th>
        <th i18n>Note Text</th>
        <th i18n>Attachment</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngIf="this.notes.length == 0">
        <td colspan="5"><h5 i18n>No notes for this quote exist</h5></td>
      </tr>
      <tr *ngFor="let note of notes">
        <td>
          {{note.quoteNote_Created}}
        </td>
        <td>
            {{note.quoteNote_CreatedBy}}
        </td>
        <td>
            {{note.quoteNote_Text}}
        </td>
        <td>
          <button *ngIf="note.quoteNote_Attachment" (click)="downloadAttachment(note)"
                  class="btn btn-success float-right" style="margin-bottom:-6px;">{{note.quoteNote_Attachment}}</button>
        </td>
        <td>
          <a *ngIf="canEdit" routerLink="/quote/note/{{note.quoteNote_ID}}" class="btn btn-success float-right" style="margin-bottom:-6px;" i18n>Edit Note</a>
        </td>
      </tr>
    </tbody>

  </table>


</div>
